import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { RoleModel } from '@fi-app/role/role.model';
import { CustomButtonModel } from '@fi-app/core/custom-button.model';
import { ApplicationSettingsModel } from '@fi-app/role/application-settings.model';
import { AppTextService } from '@fi-shared/app-text';
import { UserService } from '@fi-app/user/user.service';
import { RoleHelperService } from '../../../services/role-helper.service';
import { ApplicationSettingsTypeGroup } from '@fi-shared/types';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { BehaviorSubject } from 'rxjs';
import { RoleUsersListDialogComponent } from '@fi-app/role/role-new-layout/role-rights-cards/role-brief-info/role-users-list-dialog/role-users-list-dialog.component';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-role-brief-info',
    templateUrl: './role-brief-info.component.html',
    styleUrls: ['./role-brief-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-role-brief-info' },
    standalone: false,
})
export class RoleBriefInfoComponent {
    @Input() role: RoleModel;
    @Input() customButtons: CustomButtonModel[];
    @Input() roleApplicationSettingGroups: {
        [key: string]: ApplicationSettingsModel[];
    };
    @Input() isEditMode: boolean;

    constructor(
        private appTextService: AppTextService,
        private userService: UserService,
        private cdr: ChangeDetectorRef,
        private roleHelperService: RoleHelperService,
        private fiDialogsService: FiDialogsService,
    ) {}

    isUserInformationShown(): boolean {
        return isDefined(this.role.CreatedByProfile) || isDefined(this.role.ChangedByProfile);
    }

    getEnabledModulesAmount(): number {
        return this.getSelectedApplicationSettingsLength() + this.getSelectedCustomButtonsLength();
    }

    getColleaguesAmountText(): string {
        return this.appTextService.get('role.colleagues_belong', {
            '0': this.role.UserCount,
        });
    }

    openUsersListDialog() {
        this.fiDialogsService.custom({
            contentComponentData: new BehaviorSubject(this.role.RoleUsers),
            contentComponentRef: RoleUsersListDialogComponent,
            hideFooter: true,
            hideHeader: true,
            isHeaderCloseButtonShown: true,
            config: {
                autoFocus: false,
            },
        });
    }

    private getSelectedApplicationSettingsLength(): number {
        return Object.keys(this.roleApplicationSettingGroups).filter((key: string) => {
            return this.roleApplicationSettingGroups[key].some((applicationSettings: ApplicationSettingsModel) => {
                const applicationSettingsTypeGroup = this.roleHelperService.getAccessRightTypeGroup(
                    applicationSettings.ApplicationSettingType,
                );
                return (
                    this.roleHelperService.isApplicationSettingsModelAvailable(applicationSettings) &&
                    applicationSettingsTypeGroup !== ApplicationSettingsTypeGroup.Other
                );
            });
        }).length;
    }

    private getSelectedCustomButtonsLength(): number {
        return this.customButtons.filter((customButton: CustomButtonModel) => customButton.IsSelected).length;
    }
}
